export const statusList = [{
    status: 'Open',
    icon:   'far fa-circle ',
    color:  '#FFF200'
},
{
    status: 'Scheduled',
    icon:   'fas fa-circle ',
    color:  '#F9835A'
},
{
    status: 'Rescheduled',
    icon:   'fas fa-sync-alt ',
    color:  '#e57686'
},
{
    status: 'Tech Dispatched',
    icon:   'fal fa-arrow-alt-circle-right ',
    color:  '#ffac40'
},
{
    status: 'Tech Arrived',
    icon:   'fal fa-arrow-alt-circle-left ',
    color:  '#7575AA'
},
{
    status: 'Work Started',
    icon:   'fal fa-arrow-alt-circle-down ',
    color:  '#62b0bc'
},
{
    status: 'Work Completed',
    icon:   'fal fa-check-circle ',
    color:  '#84c971'
},
{
    status: 'Complete',
    icon:   'far fa-check-circle ',
    color:  '#84c971'
},
{
    status: 'Cancel',
    icon:   'far fa-times-circle ',
    color:  '#000000'
}];
